<template>
  <span class="rounded-full mr-1 mb-1 pl-1 pr-1 bg-primary-50 dark:bg-darkblue text-primary border-2 tag-cell">
    {{ tagName }}
  </span>
</template>

<script>
import { i18n } from '@/i18n'
import getNestedValue from '@/services/functions/getNestedValue'

export default {
  props: {
    field: String,
    format: String,
    tag: {
      type: [String, Number],
      required: true
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaultEnumId: ['id', 'key'],
      defaultEnumValue: ['value', 'name', 'Nombre'],
    }
  },
  computed: {
    tagName: function () {
      if (this.format?.length && (!this.ignoreNull || ![null, undefined].includes(this.tag))) {
        const formats = this.isJSONArray(this.format) ? JSON.parse(this.format) : [this.format]
        const warns = []
        for (const format of formats) {
          const myenum = this.$store.getters[`config/${format}`]
          if (myenum) {
            const enumItem = myenum.find(x => this.searchValue(x, [this.idEnumField, ...this.defaultEnumId]) === this.tag)
            const enumValue = this.searchValue(enumItem, [this.valueEnumField, ...this.defaultEnumValue])
            if (enumValue) {
              return enumValue
            } else {
              warns.push(i18n.t('feedback.warning.bad_conf_enum_value_warn', { field: this.field, config: format, value: this.tag })) 
            }
          } else {
            console.error(i18n.t('feedback.error.bad_enum_config_error', { field: this.field, config: format }))
          }
        }
        warns.forEach(warn => console.warn(warn))
      }
      return this.tag
    },
    idEnumField: function () {
      return this.extraparams?.idEnum
    },
    valueEnumField: function () {
      return this.extraparams?.valueEnum
    },
    ignoreNull: function () {
      return this.extraparams?.ignoreNull ?? true
    },
  },
  methods: {
    searchValue (item, keys = [], falsys = [undefined]) {
      if (item !== null && item !== undefined) {
        if (!keys.length) {
          return item
        }
        for (const key of keys) {
          if (key) {
            const value = getNestedValue(key, item)
            if (!falsys.includes(value)) {
              return value
            }
          }
        }
      }
      return undefined
    },
    isJSONArray: function (value) {
      try {
        return Array.isArray(JSON.parse(value))
      } catch {
        return false
      }
    }
  },
}
</script>

<style>

</style>
